module.exports = __webpack_public_path__ + "static/media/heart.98556c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heart.png
// module id = 786
// module chunks = 0